import { NavLink } from 'react-router-dom';
import type { MenteeLanding } from './MenteePortalService';

type Props = {
    /** From GET /mentee/dashboard. Dashboard + My Mentor LIVE only when landing === 'dashboard'. */
    landing?: MenteeLanding | null;
};

const TAB_CLASS =
    'btn border-0 py-2 px-3 mb-1 rounded-2 d-flex align-items-center gap-2';

const liveTabClass = ({ isActive }: { isActive: boolean }) =>
    `${TAB_CLASS}${isActive ? ' btn-success text-nowrap' : ' btn-light text-nowrap'}`;

const disabledTabClass = `${TAB_CLASS} btn-light text-muted opacity-50`;

const MenteePortalNav = ({ landing = null }: Props) => {
    const portalLive = landing === 'dashboard';

    return (
        <div className="card border-0 rounded-3 shadow-sm bg-darker-blue mb-3">
            <div className="d-flex flex-nowrap gap-2 p-2 overflow-auto mreg-nav" role="tablist">
                {portalLive ? (
                    <NavLink
                        to="/alumni/mentorship/mentee/dashboard"
                        className={liveTabClass}
                        end
                    >
                      <i className="bi bi-house-door-fill"></i>  Dashboard
                    </NavLink>
                ) : (
                    <button
                        type="button"
                        className={disabledTabClass}
                        disabled
                        title="Dashboard is available after you are registered and paired with a mentor"
                    >
                      <i className="bi bi-house-door-fill"></i>  Dashboard
                    </button>
                )}

                {portalLive ? (
                    <NavLink
                        to="/alumni/mentorship/mentee/mentor"
                        className={liveTabClass}
                        end
                    >
                      <i className="bi bi-mortarboard-fill"></i>  My Mentor
                    </NavLink>
                ) : (
                    <button
                        type="button"
                        className={disabledTabClass}
                        disabled
                        title="My Mentor is available after you are registered and paired with a mentor"
                    >
                      <i className="bi bi-mortarboard-fill"></i>  My Mentor
                    </button>
                )}

                {portalLive ? (
                    <NavLink
                        to="/alumni/mentorship/mentee/sessions"
                        className={liveTabClass}
                        end
                    >
                     <i className="bi bi-calendar-event-fill"></i>   Sessions
                    </NavLink>
                ) : (
                    <button
                        type="button"
                        className={disabledTabClass}
                        disabled
                        title="Sessions is available after you are registered and paired with a mentor"
                    >
                     <i className="bi bi-calendar-event-fill"></i>   Sessions
                    </button>
                )}

                <NavLink
                    to="/alumni/mentorship/mentee/register"
                    className={liveTabClass}
                    end
                >
                  <i className="bi bi-pencil-square"></i>  Registration Form
                </NavLink>
            </div>
        </div>
    );
};

export default MenteePortalNav;
